import React, { useEffect, useState } from 'react'
import { Link, redirect } from 'react-router-dom'
import { Helmet } from "react-helmet";
import toast, { Toaster } from 'react-hot-toast';
import config from "../coreFIles/config";
import Header from '../directives/header'
import Leftnav from '../directives/leftSidebar'
import Rightnav from '../directives/rightSidebar'
import Footer from '../directives/footer'
import Cookies from 'js-cookie'
import { Redirect } from 'react-router-dom';
import { getContentAction, createGeneralPaymentIntentAction, processGeneralPaymentAction } from '../Action/action';
import { getDomainStyles } from '../utils/staticDomainData';
import { getDomainIdWithData } from '../utils/domainHelpers';

const getLoginData = () => {
	try {
		const cookieData = Cookies.get('loginSuccessMember');
		return cookieData ? JSON.parse(cookieData) : null;
	} catch (error) {
		console.error('Error parsing loginSuccessMember cookie:', error);
		return null;
	}
};

const Domainid = getDomainIdWithData();
const loginData = getLoginData();

const Advertise = () => {
	// Style state for reactive styling - use static domain data
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			try {
				const domainId = Domainid?.domain_id || 0;
				const domainStyles = getDomainStyles(domainId);
				setStyle(domainStyles || []);
			} catch (error) {
				console.error('Error getting domain styles in Advertise:', error);
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const timeColor = getStyleValue('time_color');
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');


	// style end
	const [content, setcontent] = useState({});
	const [spinloader, setspinloader] = useState(0);
	const [amount, setAmount] = useState('');
	const [discussedAmount, setDiscussedAmount] = useState('');
	const [stripe, setStripe] = useState(null);
	const [cardElement, setCardElement] = useState(null);
	const [paymentProcessing, setPaymentProcessing] = useState(false);
	const [showPaymentSection, setShowPaymentSection] = useState(false);

	useEffect(() => {
		setspinloader(1)
		getcontentAPI();
		loadStripe();
	}, [])

	// Load Stripe.js
	const loadStripe = () => {
		if (window.Stripe) {
			setStripe(window.Stripe(config.stripePublishableKey));
		} else {
			const script = document.createElement('script');
			script.src = 'https://js.stripe.com/v3/';
			script.async = true;
			script.onload = () => {
				setStripe(window.Stripe(config.stripePublishableKey));
			};
			document.body.appendChild(script);
		}
	}

	// Initialize Stripe Elements when payment section is shown
	useEffect(() => {
		if (stripe && showPaymentSection) {
			const elements = stripe.elements();
			const card = elements.create('card', {
				style: {
					base: {
						fontSize: '16px',
						color: '#424770',
						'::placeholder': {
							color: '#aab7c4',
						},
					},
					invalid: {
						color: '#9e2146',
					},
				},
			});
			
			const cardElementDiv = document.getElementById('advertise-card-element');
			if (cardElementDiv) {
				card.mount('#advertise-card-element');
				setCardElement(card);

				card.on('change', ({error}) => {
					const displayError = document.getElementById('advertise-card-errors');
					if (error) {
						displayError.textContent = error.message;
					} else {
						displayError.textContent = '';
					}
				});
			}

			return () => {
				if (card) {
					card.unmount();
				}
			};
		}
	}, [stripe, showPaymentSection]);

	const getcontentAPI = async () => {
		let res = await getContentAction({ contentId: 2, domain_id: Domainid?.domain_id });
		if (res.success) {
			setcontent(res.data);
			
		}
		setspinloader(0)
	};

	const handlePayNow = async () => {
		if (!amount || parseFloat(amount) <= 0) {
			toast.error("Please enter a valid amount");
			return;
		}

		setShowPaymentSection(true);
	};

	const processPayment = async () => {
		try {
			if (!stripe || !cardElement) {
				toast.error("Payment system not ready. Please refresh the page.");
				return;
			}

			if (!amount || parseFloat(amount) <= 0) {
				toast.error("Please enter a valid amount");
				return;
			}

			setPaymentProcessing(true);

			// Step 1: Create payment intent
			const paymentIntentRes = await createGeneralPaymentIntentAction({ 
				amount: parseFloat(amount),
				discussed_amount: discussedAmount,
				member_id: loginData?.id || null,
				email: loginData?.email || '' 
			});
			
			if (!paymentIntentRes.success) {
				toast.error(paymentIntentRes.msg || "Failed to initialize payment");
				setPaymentProcessing(false);
				return;
			}

			// Step 2: Confirm payment with Stripe
			const billingName = loginData 
				? `${loginData?.fname || ''} ${loginData?.lname || ''}`.trim() || loginData?.email || ''
				: '';
			const billingEmail = loginData?.email || '';

			const { error: stripeError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmCardPayment(
				paymentIntentRes.client_secret,
				{
					payment_method: {
						card: cardElement,
						billing_details: {
							name: billingName,
							email: billingEmail,
						},
					},
				}
			);

			if (stripeError) {
				toast.error(stripeError.message || "Payment failed");
				setPaymentProcessing(false);
				return;
			}

			if (confirmedPaymentIntent.status === 'succeeded') {
				// Step 3: Process payment and save to database
				const processRes = await processGeneralPaymentAction({
					payment_intent_id: confirmedPaymentIntent.id,
					member_id: loginData?.id || null,
					discussed_amount: discussedAmount
				});

				if (processRes.success) {
					toast.success("Payment processed successfully!");
					setAmount('');
					setDiscussedAmount('');
					setShowPaymentSection(false);
					// Unmount card element
					if (cardElement) {
						cardElement.unmount();
						setCardElement(null);
					}
				} else {
					toast.error(processRes.msg || "Failed to save payment details");
				}
			} else {
				toast.error("Payment not completed");
			}
			setPaymentProcessing(false);
		} catch (error) {
			console.error('Payment Error:', error);
			toast.error("An error occurred during payment. Please try again.");
			setPaymentProcessing(false);
		}
	};
	
	return (
		<>
			<Header />
			
			<Helmet>
				<title>{content?.meta_title}</title>
				<meta name="description" content={content?.meta_desc} />
				<meta name="keywords" content={content?.meta_keywords} />
				
			</Helmet>
			
			<div className="add-section mb-3">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Leftnav />
						</div>
						<div className="col-lg-6">
							<Toaster />
							<div className="classification-section">
								{spinloader === 0 ? (
									<>
										<h2 className="page-heading" style={{ background: headerMenuColor }}>{content?.title}</h2>
										<div dangerouslySetInnerHTML={{ __html: content?.content }} ></div>
										
										{/* Payment Section */}
										<div className="bondiclassified-fromsection mt-4">
											<h2 className="page-heading" style={{ background: headerMenuColor }}>Make a Payment</h2>
											<div className="catagoryfrom">
												<div className="row">
													<div className="col-md-12 col-sm-12">
														<div className="form-group">
															<label htmlFor="amount">Amount (AUD) <span className='text-danger'>*</span></label>
															<input
																type="number"
																className="form-control"
																id="amount"
																placeholder="Enter amount"
																value={amount}
																onChange={(e) => setAmount(e.target.value)}
																min="0.01"
																step="0.01"
																required
															/>
														</div>
													</div>
													{showPaymentSection && (
														<>
															<div className="col-md-12 col-sm-12">
																<div className="alert alert-info">
																	<strong>Amount:</strong> ${amount || 0} will be charged to your card.
																</div>
															</div>
															<div className="col-md-12 col-sm-12">
																<div className="form-group">
																	<label htmlFor="advertise-card-element">Card Details <span className='text-danger'>*</span></label>
																	<div id="advertise-card-element" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff' }}>
																		{/* Stripe Card Element will be mounted here */}
																	</div>
																	<div id="advertise-card-errors" role="alert" style={{ color: '#dc3545', marginTop: '5px' }}></div>
																	<p className="mt-2" style={{ fontSize: '12px', color: '#666' }}>
																		Amount: ${amount || 0} will be charged to your card.
																	</p>
																</div>
															</div>
														</>
													)}
												</div>
											</div>
										</div>

										{/* Submit Section */}
										<div className="col-md-12 text-center mt-3 pdb-20 submitsection">
											{spinloader == '0' && !paymentProcessing ? (
												!showPaymentSection ? (
													<button
														type="button"
														className="payNow"
														onClick={handlePayNow}
														disabled={!amount || parseFloat(amount) <= 0}
														style={{ background: headerButtonColor }}
													>
														Pay Now
													</button>
												) : (
													<>
														<button
															type="button"
															className="payNow"
															onClick={() => {
																setShowPaymentSection(false);
																if (cardElement) {
																	cardElement.unmount();
																	setCardElement(null);
																}
															}}
															disabled={paymentProcessing}
															style={{ background: '#6c757d', marginRight: '10px' }}
														>
															Cancel
														</button>
														<button
															type="button"
															className="payNow"
															onClick={processPayment}
															disabled={paymentProcessing}
															style={{ background: headerButtonColor }}
														>
															{paymentProcessing ? 'Processing...' : 'Process Payment'}
														</button>
													</>
												)
											) : (
												<div className="loaderDiv">
													<img className="loaderImg" src={config.baseUrl + "img/loader.gif"} height={50} width={50} />
												</div>
											)}
										</div>
									</>
								) : (
									<div className="loaderDiv">
										<img className="loaderImg" src={config.baseUrl + "img/loader.gif"} height={50} width={50} />
									</div>
								)}
								

								
							</div>
						</div>
						<div className="col-lg-3">
							<Rightnav />
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</>
	)

}

export default Advertise;
